/** Shared 16:9 video frame sizing for mobile/tablet expanded player. */
export const MOBILE_VIDEO_FRAME_CLASS =
  'max-[1024px]:aspect-video max-[1024px]:w-[min(calc(100vw-32px),calc(56vh*16/9))] max-[1024px]:max-h-[56vh] max-[1024px]:flex-none max-[1024px]:overflow-hidden max-[1024px]:rounded-lg max-[1024px]:mx-auto';

/** Vertically centers video between top overlay chrome (~56px) and bottom player nav (~156px). */
export const MOBILE_VIDEO_FRAME_POSITION_CLASS =
  'max-[1024px]:top-[calc(env(safe-area-inset-top)+56px+(100vh-env(safe-area-inset-top)-env(safe-area-inset-bottom)-212px)/2-28px)] max-[1024px]:right-auto max-[1024px]:bottom-auto max-[1024px]:left-1/2 max-[1024px]:-translate-x-1/2 max-[1024px]:-translate-y-1/2 max-[1024px]:h-auto';

/** Desktop expanded player — full viewport below navbar; footer sits on top at z-50. */
export const DESKTOP_EXPANDED_PLAYER_INSET_CLASS =
  'min-[1025px]:inset-x-0 min-[1025px]:top-80 min-[1025px]:bottom-0';

/** Desktop player footer height for fixed bar + margin. */
export const DESKTOP_PLAYER_FOOTER_HEIGHT_CLASS = 'h-96';

/** Mobile expanded player — full viewport; bottom chrome sits on top at z-50. */
export const MOBILE_EXPANDED_PLAYER_INSET_CLASS = 'max-[1024px]:inset-0';

/** Legacy offset — only used for main content padding when player bar is visible. */
export const MOBILE_PLAYER_CHROME_BOTTOM_CLASS =
  'max-[1024px]:bottom-[calc(156px+env(safe-area-inset-bottom))]';

export const MOBILE_PLAYER_CHROME_PADDING_CLASS =
  'pb-[calc(156px+env(safe-area-inset-bottom))]';

/** Mini floating player — centered on mobile/tablet, corner on desktop. */
export const MINI_PLAYER_SIZE_CLASS =
  'aspect-video w-[min(280px,calc(100vw-48px))] overflow-hidden rounded-panel shadow-lg ring-1 ring-black/20 dark:ring-white/15';

export const MINI_PLAYER_POSITION_CLASS =
  'fixed z-30 max-[1024px]:left-1/2 max-[1024px]:top-1/2 max-[1024px]:-translate-x-1/2 max-[1024px]:-translate-y-1/2 min-[1025px]:bottom-[calc(112px+env(safe-area-inset-bottom))] min-[1025px]:right-8';
